import SellersService from "../../api/sellers.service";

const state = {
  sellers: [],
  seller: null,
};

const getters = {
  seller: (state) => state.seller,
};

const actions = {
  async fetchAllSellers(_, request_data) {
    const response = await SellersService.getAllSellers(
      request_data
    );
    return response;
  },

  async fetchSeller({ commit }, request_data) {
    const response = await SellersService.getSeller(request_data);
    commit("setSeller", response.data.data ?? state.seller);
    return response;
  },
};

const mutations = {
  setSeller: (state, data) => {
    state.seller = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
